import type { FeatureModule } from './types';
import { coreFeatures } from './core';
import { productivityFeatures } from './productivity';
import { gameFeatures } from './game';
import { financeFeatures } from './finance';
import { riyaFeatures } from './riya';

const allFeatures: FeatureModule[] = [
  ...coreFeatures,
  ...productivityFeatures,
  ...gameFeatures,
  ...financeFeatures,
  ...riyaFeatures
];

const featuresByType = new Map<string, FeatureModule[]>();
for (const feature of allFeatures) {
  const key = feature.config.featureType;
  const existing = featuresByType.get(key);
  if (existing) {
    existing.push(feature);
  } else {
    featuresByType.set(key, [feature]);
  }
}

for (const group of featuresByType.values()) {
  group.sort((a, b) => a.config.order - b.config.order);
}

const orderedFeatures: FeatureModule[] = [];
for (const group of featuresByType.values()) {
  for (const feature of group) {
    orderedFeatures.push(feature);
  }
}

export const featureGroups = featuresByType;

export const features: FeatureModule[] = orderedFeatures;

export const featureMap = new Map<string, FeatureModule>(
  features.map((feature) => [feature.config.slug, feature])
);
